import { render, staticRenderFns } from "./centerCallcenter.vue?vue&type=template&id=63cd8750&scoped=true&"
import script from "./centerCallcenter.vue?vue&type=script&lang=js&"
export * from "./centerCallcenter.vue?vue&type=script&lang=js&"
import style0 from "./centerCallcenter.vue?vue&type=style&index=0&id=63cd8750&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cd8750",
  null
  
)

export default component.exports